<template lang="pug">
.toggle(:class="[{ 'active': model }, size]" @click="toggleModel"): .toggle__switch
</template>

<script>
export default {
	name: "ToggleSwitch",
	props: {
		size: {
			type: String,
			default: "sm",
			validator: value =>
				["xs", "sm", "md", "lg", "xl"].includes(value.toLowerCase())
		},
		value: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		toggleModel() {
			this.model = !this.model;
		}
	}
};
</script>

<style lang="stylus" scoped>
.toggle
	background #fff
	border 1px solid #ddd
	border-radius 100px
	padding 2px
	transition background 0.6s
	cursor pointer

	&.xs
		height 15px
		width 30px

	&.sm
		height 20px
		width 40px

	&.md
		height 25px
		width 50px

	&.lg
		height 30px
		width 60px

	&.xl
		height 35px
		width 70px

	&__switch
		width 50%
		height 100%
		background #fff
		border-radius 100%
		box-shadow 0px .75px 2.5px rgba(0,0,0, 0.6)
		transform translateX(0%)
		transition transform 0.05s ease-in-out

	&.active
		background #72d09c
		transition background 0.6s

		.toggle__switch
			transform translateX(100%)
</style>
